export default __webpack_public_path__ + "static/media/SuisseIntl-Bold.bf8242ed.ttf";